import { SVG } from '../SVG'

const ChevronIcon = ({ style = {}, ...props }) => (
  <SVG
    viewBox='0 0 12 7'
    width='12'
    height='7'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ stroke: 'var(--color-black)', ...style }}
    strokeWidth='1.5'
    strokeLinecap='round'
    {...props}
  >
    <path d='M11 1L6 6L1 1' />
  </SVG>
)

export default ChevronIcon
